import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    openId: 'olID-0_CVngGsaDa6mgkJKgTno4k',
    rechargeInfo: null, // 充值记录的ID
    // 支付成功信息(用于充值成功页面判断是否为充值后跳转)
    paySuccessInfo: {
      status: false,  // 是否支付成功
      amount: 0,       // 支付金额
    }, 
    AirTicketResult: false,  // 需要展示机票预订的结果
    AirTicketSubmitError: '',
  },
  mutations: {
    changeValue(state, e) {
      state.openId = e;
    },
    // 保存充值人信息
    saveRechargeInfo(state, value) {
      state.rechargeInfo = value;
    },
    // 支付成功
    paySucceed(state, value) {
      state.paySuccessInfo = value;
    },
    // 重置支付状态
    ResetPayInfo(state) {
      state.paySuccessInfo = {
        status: false,
        amount: 0,
      };
    },
    // 需要展示机票预订的结果
    showAirTicketResult(state, error?) {
      state.AirTicketResult = true;
      state.AirTicketSubmitError = error;
    },
    // 重置展示机票预订的结果(false则无法进入路由)
    resetAirTicketResult(state) {
      state.AirTicketResult = false;
    },
  },
  actions: {

  },
  // 严格模式
  strict: true,
});
